import React from 'react';
import { Alert, PageHeader } from 'antd';
import ContentLayout from 'layouts/ContentLayout';
import { useTranslation } from 'react-i18next';
import i18n from 'utils/i18n';
import cn from 'classnames';
export default function Page404() {
  const { t } = useTranslation()
  return (
    <ContentLayout>
      <PageHeader title={t("Page Not Found")} subTitle={t("Something went wrong...")} />
      <Alert
        className={cn(i18n.isAr&&'isarAlert')}
        message={t("Error")}
        description={t("Sorry this page does not exist, please contact us if you are experiencing difficulties")}
        type="error"
        showIcon
      />
    </ContentLayout>
  );
}
